import { forwardRef } from 'react';
import MuiGrid from '@mui/material/Grid';
import type { SxProps, Theme } from '@mui/material/styles';
import {
  splitLegacyGridProps,
  type LegacyGridProps,
} from './utils/legacyGridProps';

/**
 * MUI 5 GridLegacy 호환 래퍼 (item/xs·system props → MUI 9 Grid API)
 */
const Grid = forwardRef<HTMLDivElement, LegacyGridProps>((props, ref) => {
  const { forwardedProps, resolvedSize, mergedSx } = splitLegacyGridProps(props);

  return (
    <MuiGrid
      ref={ref}
      {...forwardedProps}
      size={resolvedSize as LegacyGridProps['size']}
      sx={mergedSx as SxProps<Theme>}
    />
  );
});

Grid.displayName = 'Grid';

export default Grid;
export type { LegacyGridProps } from './utils/legacyGridProps';
